import chunk from 'lodash/chunk';
import React, { Children, Fragment, ReactNode } from 'react';
import { Column } from '../../components/Grid';
import { NavigationList } from '../../components/Navigation';

interface VehicleCenterColumnsProps {
  children: ReactNode;
  entriesPerColumn: number;
}

const VehicleCenterColumns = ({
  children,
  entriesPerColumn
}: VehicleCenterColumnsProps) => {
  Children.toArray(children);
  const columns = chunk(Children.toArray(children), entriesPerColumn);
  const numColumns = columns.length;
  return (
    <Fragment>
      {columns.map((entries, columnIndex) => (
        <Column key={columnIndex} large={12 / numColumns}>
          <NavigationList>{entries}</NavigationList>
        </Column>
      ))}
    </Fragment>
  );
};

export default VehicleCenterColumns;
